import { Route, Routes } from 'react-router';
import { RequireAdmin } from './auth/RequireAdmin';
import { RequirePartner } from './auth/RequirePartner';
import { AdminLayout } from './components/Admin/AdminLayout';
import { PublicLayout } from './components/PublicLayout';
import { PageAdminDashboard } from './pages/Admin/PageAdminDashboard';
import { PageAccounts } from './pages/Admin/Accounts/PageAccounts';
import { PageCollectionEdit } from './pages/Admin/Collections/PageCollectionEdit';
import { PageCollectionList } from './pages/Admin/Collections/PageCollectionList';
import { PageExperienceEdit } from './pages/Admin/Experiences/PageExperienceEdit';
import { PageExperienceList } from './pages/Admin/Experiences/PageExperienceList';
import { PageFeaturedList } from './pages/Admin/Featured/PageFeaturedList';
import { PageGuideEdit } from './pages/Admin/Guides/PageGuideEdit';
import { PageGuideList } from './pages/Admin/Guides/PageGuideList';
import { PagePartnerEdit } from './pages/Admin/Partners/PagePartnerEdit';
import { PageInvoiceDetail } from './pages/Admin/Invoices/PageInvoiceDetail';
import { PageInvoiceList } from './pages/Admin/Invoices/PageInvoiceList';
import { PagePartnerList } from './pages/Admin/Partners/PagePartnerList';
import { PageBookingRequestList } from './pages/Admin/Requests/PageBookingRequestList';
import { PageSettings } from './pages/Admin/Settings/PageSettings';
import { PageSupplierEdit } from './pages/Admin/Suppliers/PageSupplierEdit';
import { PageSupplierList } from './pages/Admin/Suppliers/PageSupplierList';
import { PageNotFound } from './pages/PageNotFound';
import { PagePartnerProfile } from './pages/Partner/PagePartnerProfile';
import { PagePartnerRequests } from './pages/Partner/PagePartnerRequests';
import { PageCatalog } from './pages/Public/Catalog/PageCatalog';
import { PageCollectionDetail } from './pages/Public/CollectionDetail/PageCollectionDetail';
import { PageExperienceDetail } from './pages/Public/ExperienceDetail/PageExperienceDetail';
import { PageGuides } from './pages/Public/Guides/PageGuides';
import { PageHome } from './pages/Public/Home/PageHome';

export function PageContent() {
  return (
    <Routes>
      {/* Public site */}
      <Route element={<PublicLayout />}>
        <Route path='/' element={<PageHome />} />
        <Route path='/catalog' element={<PageCatalog />} />
        <Route path='/tour-leaders' element={<PageGuides />} />
        <Route path='/experiences/:experienceId' element={<PageExperienceDetail />} />
        <Route path='/collections/:collectionId' element={<PageCollectionDetail />} />
      </Route>

      {/* Admin CMS — super-admins only */}
      <Route element={<RequireAdmin />}>
        <Route path='/admin' element={<AdminLayout />}>
          <Route index element={<PageAdminDashboard />} />
          <Route path='experiences' element={<PageExperienceList />} />
          <Route path='experiences/new' element={<PageExperienceEdit mode='new' />} />
          <Route path='experiences/:experienceId/edit' element={<PageExperienceEdit mode='edit' />} />
          <Route path='featured' element={<PageFeaturedList />} />
          <Route path='collections' element={<PageCollectionList />} />
          <Route path='collections/new' element={<PageCollectionEdit mode='new' />} />
          <Route path='collections/:collectionId/edit' element={<PageCollectionEdit mode='edit' />} />
          <Route path='requests' element={<PageBookingRequestList />} />
          <Route path='invoices' element={<PageInvoiceList />} />
          <Route path='invoices/:invoiceId' element={<PageInvoiceDetail />} />
          <Route path='guides' element={<PageGuideList />} />
          <Route path='guides/new' element={<PageGuideEdit mode='new' />} />
          <Route path='guides/:guideId/edit' element={<PageGuideEdit mode='edit' />} />
          <Route path='suppliers' element={<PageSupplierList />} />
          <Route path='suppliers/new' element={<PageSupplierEdit mode='new' />} />
          <Route path='suppliers/:supplierId/edit' element={<PageSupplierEdit mode='edit' />} />
          <Route path='partners' element={<PagePartnerList />} />
          <Route path='partners/new' element={<PagePartnerEdit mode='new' />} />
          <Route path='partners/:partnerId/edit' element={<PagePartnerEdit mode='edit' />} />
          <Route path='accounts' element={<PageAccounts />} />
          <Route path='settings' element={<PageSettings />} />
        </Route>
      </Route>

      {/* Partner area — partners only. Accounts are created by redeeming
          an invitation at /invite/:inviteId (see App.tsx). Deliberately uses the
          public site's top-nav layout rather than an admin-style sidebar: a
          partner has two pages, and the sidebar implied a CMS they don't have. */}
      <Route element={<RequirePartner />}>
        <Route element={<PublicLayout />}>
          <Route path='/partner' element={<PagePartnerProfile />} />
          <Route path='/partner/requests' element={<PagePartnerRequests />} />
        </Route>
      </Route>

      <Route path='*' element={<PageNotFound />} />
    </Routes>
  );
}
